<template>
  <div
    class="animated fadeIn"
    v-model="tabIndex"
    v-permission="'VIEW_VULNERABILITY'"
  >
    <b-tabs
      class="body-bg-color"
      style="border-left: 0; border-right: 0; border-top: 0"
    >
      <b-tab
        ref="occurrences"
        style="border-left: 0; border-right: 0; border-top: 0"
        @click="routeTo()"
        :active="tabIndex === 0"
        :lazy="!visitedTabs.has(0)"
      >
        <template v-slot:title
          ><i class="fa fa-shield"></i>
          {{ $t('message.vulnerabilities_by_occurrence') }}</template
        >
        <VulnerabilityAuditByOccurrence />
      </b-tab>
      <b-tab
        ref="grouped"
        style="border-left: 0; border-right: 0; border-top: 0"
        @click="routeTo('grouped')"
        :active="tabIndex === 1"
        :lazy="!visitedTabs.has(1)"
      >
        <template v-slot:title
          ><i class="fa fa-shield"></i>
          {{ $t('message.grouped_vulnerabilities') }}</template
        >
        <VulnerabilityAuditGroupedByVulnerability />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import permissionsMixin from '@/mixins/permissionsMixin';
import VulnerabilityAuditGroupedByVulnerability from '@/views/globalAudit/VulnerabilityAuditGroupedByVulnerability';
import VulnerabilityAuditByOccurrence from '@/views/globalAudit/VulnerabilityAuditByOccurrence';

export default {
  mixins: [permissionsMixin],
  components: {
    VulnerabilityAuditByOccurrence,
    VulnerabilityAuditGroupedByVulnerability,
  },
  methods: {
    routeTo(path) {
      if (path) {
        this.visitedTabs.add(path === 'grouped' ? 1 : 0);
        if (
          !this.$route.fullPath.toLowerCase().includes('/' + path.toLowerCase())
        ) {
          this.$router.push({ path: '/vulnerabilityAudit/' + path });
        }
      } else if (
        this.$route.fullPath !== '/audit' &&
        this.$route.fullPath !== '/vulnerabilityAudit/'
      ) {
        this.visitedTabs.add(0);
        this.$router.push({ path: '/vulnerabilityAudit/' });
      }
    },
    getTabFromRoute: function () {
      let pattern = new RegExp('/vulnerabilityAudit\\/([^\\/]*)', 'gi');
      let tab = pattern.exec(this.$route.fullPath.toLowerCase());
      tab && tab[1] && tab[1].toLowerCase() === 'grouped'
        ? (this.tabIndex = 1)
        : (this.tabIndex = 0);
      return this.$refs[tab && tab[1] ? tab[1].toLowerCase() : 'occurrences'];
    },
  },
  beforeMount() {
    this.getTabFromRoute();
    this.visitedTabs.add(this.tabIndex);
  },
  watch: {
    $route(to, from) {
      this.getTabFromRoute().activate();
    },
  },
  data() {
    return {
      tabIndex: 0,
      visitedTabs: new Set(),
    };
  },
};
</script>
